import request from '@/utils/request'

// -----------------------公司---------------------------
/**
 * 缓存车辆操作
 * 部门idprivate Long id;
 * 全部可运营车辆 private boolean allCar;
 * 增加还是减少private boolean increase;
 * true 增加 右移
 * false 减少 左移
 * 车辆ID集合 private List<Long> carIdList;
 */
export function switchCarStoreList(data = {}) {
  return request({
    url: '/admin/v1/dept/car/switch',
    method: 'POST',
    data,
  })
}
export function carSeriesFuzzNameSearch(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/carSeriesFuzzNameSearch',
    method: 'POST',
    data,
  })
}
// 释放缓存操作 id 右侧部门ID
export function releaseCarStoreList(data = {}) {
  return request({
    url: 'admin/v1/dept/car/release',
    method: 'POST',
    data,
  })
}
// 公司启用/禁用状态更新接口
export function companyUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/updateState',
    method: 'POST',
    data,
  })
}
// 新建公司接口
export function companyAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/add',
    method: 'POST',
    data,
  })
}
// 公司详情页查询接口
export function companyDetail(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/detail',
    method: 'POST',
    data,
  })
}
// 公司详情页编辑接口
export function companyEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/edit',
    method: 'POST',
    data,
  })
}

// 客户列表导出接口
export function customerExport(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/export',
    method: 'POST',
    data,
  })
}
// 客户管理新增接口
export function customerAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/add',
    method: 'POST',
    data,
  })
}

// 客户管理编辑接口
export function customerEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/edit',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function customerUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/updateState',
    method: 'POST',
    data,
  })
}
// 服务商列表查询接口
export function providerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}
// 服务商新增接口
export function providerAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/add',
    method: 'POST',
    data,
  })
}
// 服务商编辑接口
export function providerEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/edit',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function providerUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/updateState',
    method: 'POST',
    data,
  })
}
// 车型列表查询接口
export function carModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/list',
    method: 'POST',
    data,
  })
}
// 品牌查询接口
export function carBrandList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/brandList',
    method: 'POST',
    data,
  })
}
// 车型列表查询接口
export function carSeriesList(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/seriesList',
    method: 'POST',
    data,
  })
}

// 新增车型
export function carModelAdd(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/add',
    method: 'POST',
    data,
  })
}

/**
 * 车型详情接口
 * @param {*} data
 * */
export function carModelDetail(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/detail',
    method: 'POST',
    data,
  })
}

// 编辑车型
export function carModelEdit(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/edit',
    method: 'POST',
    data,
  })
}

// 启用禁用状态更新接口
export function carModelUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/updateState',
    method: 'POST',
    data,
  })
}
/**
 * 合同模板列表查询接口
 * @param {number} data.state - 模板状态 0-禁用 1-启用
 * @returns
 */
export function contractTmpList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/list',
    method: 'POST',
    data,
  })
}
// 合同模板列表新增接口
export function contractTmpAdd(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/add',
    method: 'POST',
    data,
  })
}
// 合同模板编辑接口
export function contractTmpEdit(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/edit',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function contractTmpUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/updateState',
    method: 'POST',
    data,
  })
}
// 合同模板动态字段查询接口
export function contractTmpVariables(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/variables',
    method: 'POST',
    data,
  })
}
// 合同模板预览接口
export function contractTmpPreview(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/preview',
    method: 'POST',
    data,
  })
}
// 系统日志接口
export function operationLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operationLog/list',
    method: 'POST',
    data,
  })
}
//* *--------------*员工账户管理*----------------** */
// 系统员工账号管理所属角色
export function roleList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/list',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理新建员工
export function userAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/addUser',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理编辑员工
export function userEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/editUser',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理启用/禁用
export function userUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/updateState',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理修改密码
export function resetPassword(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/resetPassword',
    method: 'POST',
    data,
  })
}
// 公告列表查询接口
export function noticeList(data) {
  return request({
    url: '/admin/v1/vehicle/notice/list',
    method: 'POST',
    data,
  })
}
// 公告详情接口
export function noticeDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/notice/detail',
    method: 'POST',
    data,
  })
}
// 公告新增接口
export function noticeAdd(data) {
  return request({
    url: '/admin/v1/vehicle/notice/add',
    method: 'POST',
    data,
  })
}
// 公告编辑接口
export function noticeEdit(data) {
  return request({
    url: '/admin/v1/vehicle/notice/edit',
    method: 'POST',
    data,
  })
}
// 公告启用/禁用状态接口
export function noticeUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/notice/updateState',
    method: 'POST',
    data,
  })
}

// 公司超管用户列表接口
export function superAdminList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/userList',
    method: 'POST',
    data,
  })
}
// 公司超管用户编辑接口
export function superAdminEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/editUser',
    method: 'POST',
    data,
  })
}
// 员工角色新增/编辑接口
export function roleAddEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/saveOrUpdate',
    method: 'POST',
    data,
  })
}
// 员工角色删除接口
export function roleDel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/delete',
    method: 'POST',
    data,
  })
}
// 公司信息营业执照OCR接口
export function ocrBizLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/bizLicense',
    method: 'POST',
    data,
  })
}
// new公司信息营业执照OCR接口
export function detailedBizLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/detailedBizLicense',
    method: 'POST',
    data,
  })
}
// 身份证OCR接口
export function ocrIdcard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/idcard',
    method: 'POST',
    data,
  })
}

// 公司员工删除
export function userDelete(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/deleteStaff',
    method: 'POST',
    data,
  })
}

// 客户管理详情页查看接口
export function customerExcel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/importExcel',
    method: 'POST',
    data,
  })
}

// 服务商详情页接口
export function companyProviderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/detail',
    method: 'POST',
    data,
  })
}

// 自定义标签查询
export function getTenantCustomTagList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}

// 预览
export function effectPreview(params) {
  return request({
    url: '/admin/v1/vehicle/contract/template/effectPreview',
    method: 'get',
    params,
  })
}
// 检查租户是否开通服务
export function checkConfigState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/getState',
    method: 'POST',
    data,
  })
}


// 待办任务记录列表
export function affairsItems(data = {}) {
  return request({
    url: '/admin/v1/vehicle/affairs/items',
    method: 'POST',
    data,
  })
}

// 禁用账户是否是审批人查询
export function isAuditor(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/isApprover',
    method: 'POST',
    data,
  })
}


// ----------------------------------集团--------------------------------------
// 集团角色列表
export function tRoleList(data = {}) {
  return request({
    url: '/admin/v1/role/list',
    method: 'POST',
    data,
  })
}

// 删除集团角色
export function tRoleDel(data = {}) {
  return request({
    // url: '/admin/v1/vehicle/user/rbac/role/tenant/delete',
    url: '/admin/v1/role/delete',
    method: 'POST',
    data,
  })
}
export function getPreRoleDetail(data = {}) {
  return request({
    url: '/admin/v1/role/detail',
    method: 'POST',
    data,
  })
}
export function getResourceTreeV2(data = {}) {
  return request({
    url: '/saas/v1/resource/tree/V2',
    method: 'POST',
    data,
  })
}

// 新增集团角色
export function tRoleAddEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/tenant/add',
    method: 'POST',
    data,
  })
}
export function addPreRole(data = {}) {
  return request({
    url: '/admin/v1/role/add',
    method: 'POST',
    data,
  })
}

// 修改集团角色
export function roleUpdate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/tenant/update',
    method: 'POST',
    data,
  })
}
export function editPreRole(data = {}) {
  return request({
    url: '/admin/v1/role/edit',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查询可以配置的角色权限
 * @apiUrl /user/resource/optionalTree
 */
export function tGetOptionalTree(data = {}) {
  // return Promise.resolve({
  //   data: resource
  // })
  return request({
    url: '/admin/v1/vehicle/user/resource/optionalTree',
    method: 'post',
    data,
  })
}


// 用户列表
export function tUserList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/listStaff',
    method: 'POST',
    data,
  })
}

// 新建用户
export function tUserAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/addStaff',
    method: 'POST',
    data,
  })
}

// 编辑用户
export function tUserEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/editStaff',
    method: 'POST',
    data,
  })
}

// 启用、禁用账户
export function tUserUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/updateState',
    method: 'POST',
    data,
  })
}

// 删除账户
export function tUserDelete(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/deleteStaff',
    method: 'POST',
    data,
  })
}

// 修改密码
export function tResetPassword(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/resetPassword',
    method: 'POST',
    data,
  })
}


// 通过手机号查看绑定关系
export function isRelatedQuery(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/queryOrganization',
    method: 'POST',
    data,
  })
}

// 不可租标签查询
export function getNonRentableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/non-rentable/list',
    method: 'POST',
    data,
  })
}

// 联动网约运营数据 start
// 查询共享网约平台列表
export function getShareList(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/config/shareList',
    method: 'POST',
    data,
  })
}

// 获取DCP专属ID(secretId)
export function getSecretId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/get',
    method: 'POST',
    data,
  })
}

// 获取共享码列表(shareId)
export function getShareIdList(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/config/secretList',
    method: 'POST',
    data,
  })
}

// 校验共享码
export function checkShareId(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/config/checkSecret',
    method: 'POST',
    data,
  })
}

// 关闭共享码
export function closeShareId(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/config/stopSecret',
    method: 'POST',
    data,
  })
}
// 联动网约运营数据 end

// E签宝-机构列表
export function getContractOrgList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/list',
    method: 'POST',
    data,
  })
}

// E签宝-新增机构
export function addContractOrg(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/add',
    method: 'POST',
    data,
  })
}

// E签宝-机构详情
export function getContractOrgDetail(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/detail',
    method: 'POST',
    data,
  })
}

// E签宝-机构印章列表
export function getContractOrgSealList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/sealList',
    method: 'POST',
    data,
  })
}

// E签宝-状态修改
export function updateContractOrgState(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/updateState',
    method: 'POST',
    data,
  })
}

// E签宝-使用明细
export function getChargeRecordList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/chargeRecordList',
    method: 'POST',
    data,
  })
}

// E签宝-选择印章
export function getContractOrgSealAuth(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/sealAuth',
    method: 'POST',
    data,
  })
}

// E签宝-下一步
export function nextStepForContractOrg(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/nextStep',
    method: 'POST',
    data,
  })
}
// 部门
export function getDeptList(data = {}) {
  return request({
    url: '/admin/v1/dept/list',
    method: 'POST',
    data,
  })
}
// 新增部门
export function addDept(data = {}) {
  return request({
    url: '/admin/v1/dept/add',
    method: 'POST',
    data,
  })
}
export function editDept(data = {}) {
  return request({
    url: '/admin/v1/dept/edit',
    method: 'POST',
    data,
  })
}
export function checkDept(data = {}) {
  return request({
    url: '/admin/v1/dept/check',
    method: 'POST',
    data,
  })
}
export function deleteDept(data = {}) {
  return request({
    url: '/admin/v1/dept/delete',
    method: 'POST',
    data,
  })
}
// 部门排序
export function deptSort(data = {}) {
  return request({
    url: '/admin/v1/dept/sort',
    method: 'POST',
    data,
  })
}

// 获取员工
export function getStaffList(data = {}) {
  return request({
    url: '/admin/v1/user/list',
    method: 'POST',
    data,
  })
}

// 获取脱敏员工
export function getSensitiveStaffList(data = {}) {
  return request({
    url: '/admin/v1/user/list/sensitive',
    method: 'POST',
    data,
  })
}

export function getStaffDetail(data = {}) {
  return request({
    url: '/admin/v1/user/detail',
    method: 'POST',
    data,
  })
}

// 获取脱敏员工
export function getStaffDetailSensitive(data = {}) {
  return request({
    url: '/admin/v1/user/detail/sensitive',
    method: 'POST',
    data,
  })
}

// 新增员工
export function addStaff(data = {}) {
  return request({
    url: '/admin/v1/user/add',
    method: 'POST',
    data,
  })
}
export function editStaff(data = {}) {
  return request({
    url: '/admin/v1/user/edit',
    method: 'POST',
    data,
  })
}
export function enableStaff(data = {}) {
  return request({
    url: '/admin/v1/user/enable',
    method: 'POST',
    data,
  })
}
export function setPassword(data = {}) {
  return request({
    url: '/admin/v1/user/setPassword',
    method: 'POST',
    data,
  })
}
export function setDept(data = {}) {
  return request({
    url: '/admin/v1/user/setDept',
    method: 'POST',
    data,
  })
}
export function getDeptCarList(data = {}) {
  return request({
    url: '/admin/v1/dept/car/list',
    method: 'POST',
    data,
  })
}
export function connectCarDept(data = {}) {
  return request({
    url: '/admin/v1/dept/car/connect',
    method: 'POST',
    data,
  })
}

// 获取乾三收款信息
export function getQianSanPayInfo(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/payInfo',
    method: 'POST',
    data,
  })
}

// 提交购买份额
export function submitPurchase(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/purchase',
    method: 'POST',
    data,
  })
}

// 获取已授权机构下拉框
export function getOrgListSimple(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/listSimple',
    method: 'POST',
    data,
  })
}

// 购买记录列表
export function getPurchaseRecordList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/purchaseRecordList',
    method: 'POST',
    data,
  })
}

// 申请开票
export function applyInvoice(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/purchase/invoice',
    method: 'POST',
    data,
  })
}

// 下载发票
export function downloadInvoice(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract/org/purchase/invoice/download',
    method: 'POST',
    data,
  })
}

// 企业主体列表接口
export function getMerchantList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/list',
    method: 'POST',
    data,
  })
}

// 创建/编辑企业主体接口
export function saveOrEditMerchant(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/saveAndEdit',
    method: 'POST',
    data,
  })
}

// 根据组织Id获取企业主体的信息
export function getMerchantInfoById(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/getSingleEnterpriseInfo',
    method: 'POST',
    data,
  })
}

// 校验企业注意是否重复
export function validEnterpriseAndGetInfo(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/validEnterpriseRepeatability',
    method: 'POST',
    data,
  })
}

// 查询企业主体列表
export function getMerchantNameList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/getWithholdMerchantNameList',
    method: 'POST',
    data,
  })
}
/**
 * 获取合同模板预览地址
 * @param {number} data.id 合同模版id
 * @param {number} data.bizType 1-租赁合同，2-代扣合同，不传的话默认为1
 * @returns {Promise<{data: string, code: number}>} data: 预览地址
 */
export function contractTemplateEffectPreviewV2Api(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/effectPreviewV2',
    method: 'POST',
    data,
  })
}

/**
 * ai校验合同模板是否有效
 * @param {number} data.id 合同模板id
 * @returns {Promise<{data: number, message: string, code: number}>} data: 0-无效，1-有效，-1-未知
 */
export function contractCheckValid(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/checkValid',
    method: 'POST',
    data,
  })
}
